module.exports = __webpack_public_path__ + "assets/puppet.9f455bdc.svg";